import Button from '@mui/material/Button';
// import {AppBar, Toolbar, Typography,} from "@material-ui/core";
import Nav from './nav';
import axios from 'axios';

import React, {Component} from 'react';
import {Container, Grid} from "@mui/material";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';


class LoadImage extends Component {

    state = {

        // Initially, no file is selected
        selectedFile: null,
        foundImage: null
    };


    // On file select (from the pop up)
    onFileChange = event => {
        // Update the state
        this.setState({
            selectedFile: event.target.files[0],
            addImage: null
        });

    };

    // On file upload (click the upload button)
    onFileUpload = () => {

        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        formData.append(
            "image",
            this.state.selectedFile,
            this.state.selectedFile.name
        );

        // Request made to the backend api
        // Send formData object
        axios.post("/uploadfiles/", formData)
            .then(r => {
                this.setState({foundImage: "data:status/string"})
            })
    };

    // File content to be displayed after
    // file upload is complete
    fileData = () => {
        if (this.state.foundImage) {
            return (
                <div>
                    <h2> Изображение добавлено </h2>
                </div>
            )
        }

        if (this.state.selectedFile) {

            return (
                <div>
                    <h2>Информация об изображении:</h2>

                    <p>Имя файла: {this.state.selectedFile.name}</p>

                    <p>Тип файла: {this.state.selectedFile.type}</p>

                    <p>
                        Дата последнего изменения:{" "}
                        {this.state.selectedFile.lastModifiedDate.toDateString()}
                    </p>

                    <img className="uploadedImage" src={URL.createObjectURL(this.state.selectedFile)}/>

                </div>
            );
        } else {
            return (
                <div>
                    <br/>
                    <h4>Выберите файл для добавления</h4>
                </div>
            );
        }
    };

    render() {

        return (
            <Container >
                <Nav />
                <div>
                    <h1>
                        Добавление изображения
                    </h1>
                    <div>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>

                                <Button variant="contained" component="label" color="primary">
                                    {" "}
                                    Загрузить изображение
                                    <input id="image" type="file" onChange={this.onFileChange} hidden/>
                                </Button>
                            </Grid>


                            {/*<input type="file" onChange={this.onFileChange} />*/}
                            <Grid item xs={6}>
                                <Button variant="contained" component="label" color="primary">
                                    {" "}
                                    Добавить изображение в базу
                                    <input type="button" onClick={this.onFileUpload} hidden/>
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                    {this.fileData()}
                </div>
            </Container>
        );
    }
}

export default LoadImage;
